import React from 'react';
import Hero from '../components/Hero';
import Services from '../components/Services';
import ValueProp from '../components/ValueProp';
import Publications from '../components/Publications'; // New
import Activities from '../components/Activities'; // New
import Impact from '../components/Impact';
import Future from '../components/Future';
import Collaboration from '../components/Collaboration';
import About from '../components/About';
import Blog from '../components/Blog';
import Footer from '../components/Footer';

const LandingPage = () => {
  return (
    <div>
      <Hero />
      <Services />
      <ValueProp />
      <Publications />
      <Activities />
      <Impact />
      <Future />
      <Collaboration />
      <About />
      <Blog />
      <Footer />
    </div>
  );
};

export default LandingPage;